import React, { Component } from 'react';
import './SubmitButton.scss';

interface SubmitButtonProps extends React.HTMLProps<HTMLInputElement> {
    content?: string;
}

class SubmitButton extends Component<SubmitButtonProps> {
    render() {
        return (
            <div className={this.props.className}>
                <button type="submit" className="btn submit-btn">{this.props.content}</button>
            </div>
        )
    }
}

export default SubmitButton;